import { BaseNode } from './BaseNode';

export { BaseNode as TriggerNode } from './BaseNode';
export { BaseNode as ActionNode } from './BaseNode';
export { BaseNode as CoreNode } from './BaseNode';

export const NodeTypes = {
  TriggerNode: BaseNode,
  ActionNode: BaseNode,
  CoreNode: BaseNode,
};
